import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
export default {
  container: (background: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    background: background || theme.rawColors.lightGreyBg2,
    pt: MARGINS_BLOCKS[marginTop],
    pb: MARGINS_BLOCKS[marginBottom],
    position: 'relative',
    zIndex: theme.zIndex.documentHigh
  }),
  tilesContainer: {
    p: ['0 16px', '0 16px', '0 24px', '0 13.75vw', '0 13.543191801vw', '0 10.763888889vw', '0 10.5625vw', '0 10.15625vw'],
    display: 'grid',
    gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(4, 1fr)', 'repeat(4, 1fr)', 'repeat(5, 1fr)'],
    columnGap: ['2px', '2px', '4px', '20px', '20px', '24px'],
    rowGap: ['24px', '24px', '24px', '80px', '80px', '80px']
  }
};